export default {
  default: () => import("/home/node/app/layouts/default.vue").then(m => m.default || m),
  "ticket-layout": () => import("/home/node/app/layouts/ticket-layout.vue").then(m => m.default || m)
}